import { Dispatch } from 'redux';

import { ISelectUserSearchCondition, setSelectUserData } from '../actions/user';
import AbstractScenario from './AbstractScenario';

/**
 * ユーザ選択シナリオファクトリ
 */
export default class UserScenarioFactory {
	/**
	 * ユーザ選択情報取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchSelectUsers(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			ISelectUserSearchCondition
		> {
			protected process(arg: ISelectUserSearchCondition) {
				const params = {
					_tsqPagerPageNo: '1',
					_tsqPagerPageSize: '99999',
					_tsqPagerSearchType: '3',
					_tsqPagerSortByAsc: '',
					_tsqPagerSortByDesc: '',
					_tsqPagerSortColumn: '',
					_tsqPagerSortOrder: '',
					accessType: 10,
					detail: [],
					isFirst: 0,
					level: '',
					userInfoFlg: 1,
					...arg,
				};
				return this.read(
					'com_user_UserSelectBlockCollection',
					params
				).then(data => {
					this.dispatch(
						setSelectUserData({
							data: data.userList,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}
}



// WEBPACK FOOTER //
// ./src/scenario/UserScenarioFactory.ts